<template lang="pug">
  form.feature-update(@submit.prevent="updateStatus")
    .form-field
      label
        .form-field-select
          SelectInput(
            header="Status",
            :options="statuses",
            :disabled="feature.isReadOnly",
            label="label",
            v-model="updateStatusForm.status._id",
            @change="setStatus"
          )
    .status-details(v-if="showUpdateStatus")
      .form-field
        textarea(v-model="updateStatusForm.comment", placeholder="Comment")
      .form-field
        SubmitButton(label="Submit", :formState="statusState")
        button.button.button-none(type="button", @click="reset") Cancel
</template>

<script>

import { mapState } from 'vuex'
import SelectInput from '@/components/helpers/SelectInput'

export default {
  name: 'FeatureStatus',
  components: {
    SelectInput
  },
  props: {
  },
  beforeMount () {
    //console.log(this.feature)
    this.updateStatusForm.status = Object.assign({}, this.feature.status)
  },
  data () {
    return {
      showUpdateStatus: false,
      statusState: 'initial',
      updateStatusForm: {
        status: null,
        comment: ''
      },
    }
  },
  computed: {
    ...mapState({
      statuses: state => state.statuses,
      feature: state => state.features.selected
    })
  },
  methods: {
    reset () {
      this.showUpdateStatus = false
      this.updateStatusForm = {
        status: Object.assign({}, this.feature.status),
        comment: ''
      }
    },
    setStatus () {
      this.showUpdateStatus = true
    },
    updateStatus () {
      let update = {
        slug: this.feature.slug,
        status: {
          status: this.updateStatusForm.status._id,
          comment: this.updateStatusForm.comment
        }
      }

      this.statusState = 'pending'
      this.$store.dispatch('features/updateStatus', update)
        .then((activity) => {
          this.statusState = 'initial'
          this.showUpdateStatus = false
          this.updateStatusForm.comment = ''
          this.$store.dispatch('activities/addStatusUpdate', activity)
        }, () => {
          this.statusState = 'error'
        })
    },
  }
}
</script>

<style scoped lang="stylus">
.feature-update
  margin-bottom $spacing-3
  .form-field
    margin-bottom $spacing


</style>
